<template lang="pug">
  article.artigo
    slot(name="loading")
    slot(name="header")
    slot(name="feedback")
    slot(name="content")
    slot(name="footer")
</template>

<style lang="scss">
  .artigo {
    margin: 40px 0;

    .texto { margin: 15px 0; }

    @include media(">=tablet") {
      .texto { padding: 0 3rem }
    }

    @include media(">=desktop") {
      .texto { padding: 0 3rem }
    }
  }
</style>

<script>
export default {
  name: 'conteudo'
}
</script>



// WEBPACK FOOTER //
// Conteudo.vue?3aaeb860